import { forwardRef } from 'react';
import IconAddFilled from '~icons/carbon/add-filled';
import { su, theme, typography } from '@arc/frontend/ui-theme';
import { buttonIconAddStyles } from './ButtonIconAdd';
// eslint-disable-next-line @typescript-eslint/no-shadow
export const ButtonIconAddWithText = forwardRef(function ButtonIconAddWithText(props, ref) {
  const {
    side = 'left',
    text,
    buttonStyle,
    small = false,
    ...buttonProps
  } = props;
  return <button data-testid="button-add" type="button" {...buttonProps} css={[typography.clickableLink, su.textMd, {
    color: theme.colors.text.tableHeader,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:disabled, &[data-disabled=true]': {
      color: theme.colors.text.hint,
      cursor: 'default',
      '& [data-icon]': {
        color: theme.colors.action.disabledBackground
      }
    }
  }, buttonStyle, process.env.NODE_ENV === "production" ? "" : ";label:ButtonIconAddWithText;"]} ref={ref}>
			{side === 'left' ? text : null}
			<IconAddFilled data-icon css={[buttonIconAddStyles.icon, "width:1.25rem;height:1.25rem;", side === 'left' ? {
      marginLeft: '0.5rem'
    } : {
      marginRight: '0.5rem'
    }, small && {
      width: 18,
      height: 18
    }, process.env.NODE_ENV === "production" ? "" : ";label:ButtonIconAddWithText;"]} />

			{side === 'right' ? text : null}
		</button>;
});